import {type PillType} from '@hm/fundamental'

import {RiaStatus} from '../types'

export const statusColor: Record<RiaStatus, PillType> = {
  [RiaStatus.New]: 'info',
  [RiaStatus.Pending]: 'warning',
  [RiaStatus.InProgress]: 'primary',
  [RiaStatus.Completed]: 'positive',
  [RiaStatus.Waived]: 'neutral',
  [RiaStatus.Rejected]: 'negative'
}
